import {exhaustive} from '@freckle/exhaustive'
import type {
  SyncResultT,
  SyncResultFailureT,
  SyncResultSuccessT
} from '@freckle/educator-entities/ts/common/models/roster-sync'

export function partitionResults(
  results: Array<SyncResultT>
): [Array<SyncResultFailureT>, Array<SyncResultSuccessT>] {
  const failures: SyncResultFailureT[] = []
  const successes: SyncResultSuccessT[] = []
  results.forEach(result => {
    switch (result.tag) {
      case 'SyncResultSuccess':
        successes.push(result.contents)
        break
      case 'SyncResultFailure':
        failures.push(result.contents)
        break
      default:
        return exhaustive(result, 'SyncResultT')
    }
  })
  return [failures, successes]
}
